import React, { useEffect, useState } from "react";

export default function DevDet() {
  const [front, setFront] = useState(null);
  const [back, setBack] = useState(null);
  useEffect(() => {
    fetch("https://api.github.com/users/habiib4")
      .then((response) => response.json())
      .then((res) => setFront(res))

      .catch((err) => {
        setFront({
          name: "Ahsan Habib",
          avatar_url: require("../../Assets/vectors/maleUser.svg").default,
          html_url: "https://github.com/habiib4",
          public_repos: 0,
          followers: 0,
          following: 0,
        });
      });
    fetch("https://api.github.com/users/majhar-nayem")
      .then((response) => response.json())
      .then((res) => setBack(res))
      .catch((err) => {
        setBack({
          name: "Majharul Islam",
          avatar_url: require("../../Assets/vectors/maleUser.svg").default,
          html_url: "https://github.com/majhar-nayem",
          public_repos: 0,
          followers: 0,
          following: 0,
        });
      });
  }, []);

  console.log(front);

  return (
    <div className="mainContainer p2">
      {front && back && (
        <div
          className="grid grid2Fr"
          style={{ gap: "1.5rem", marginBottom: "2rem" }}
        >
          <div
            className="card p2 flexColumn"
            style={{ boxShadow: "0 0 12px rgb(0 0 0 / 24%)" }}
          >
            <div>
              <img
                className="profilePic"
                style={{
                  width: "110px",
                  height: "110px",
                  marginBottom: "0.5rem",
                  borderRadius: "100%",
                }}
                src={front.avatar_url}
                alt=""
              />
              <h2>{front.name}</h2>
              <h5 style={{ color: "#08664b" }}>Frontend Developer</h5>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "0.175rem",
                  marginBottom: ".5rem",
                }}
              >
                <h5 style={{ marginRight: "0.5rem", color: "#08664b" }}>
                  Projects: <span>{front.public_repos}</span>
                </h5>
                <h5 style={{ marginRight: "0.5rem", color: "#08664b" }}>
                  Followers: <span>{front.followers}</span>
                </h5>
                <h5 style={{ color: "#08664b" }}>
                  Following: <span>{front.following}</span>
                </h5>
              </div>
            </div>
            <div
              className="flexColumn"
              style={{ justifyContent: "space-between", height: "100%" }}
            >
              <div>
                <p style={{ fontSize: "15px" }}>
                  I am a frontend developer with 2 years experience of creating
                  interactive web apps using react.js. I am also familiar with
                  backend technologies like node.js.
                </p>
              </div>
              <div className="flexRow mt05">
                <a
                  href="https://www.facebook.com/habiib4/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{
                    marginRight: "0.5rem",
                  }}
                >
                  <img
                    src={require("../../Assets/vectors/facebook.svg").default}
                    style={{ width: "24px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCVfket8aw5qgSRWTpkQh5cQ"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/youtube.svg").default}
                    style={{ width: "26px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.instagram.com/habiib4/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/instagram.svg").default}
                    style={{ width: "25px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.github.com/habiib4/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/github.svg").default}
                    style={{ width: "24px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://twitter.com/ahsan_habiib4"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/twitter.svg").default}
                    style={{ width: "25px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.linkedin.com/in/ahsan-habib-129a44145/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../Assets/vectors/linkedin.svg").default}
                    style={{ width: "25px" }}
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
          <div
            className="card p2 flexColumn"
            style={{ boxShadow: "0 0 12px rgb(0 0 0 / 24%)" }}
          >
            <div>
              <img
                className="profilePic"
                style={{
                  width: "110px",
                  height: "110px",
                  marginBottom: "0.5rem",
                  borderRadius: "100%",
                }}
                src={back.avatar_url}
                alt=""
              />
              <h2>{back.name}</h2>
              <h5 style={{ color: "#08664b" }}>Backend Developer</h5>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "0.175rem",
                  marginBottom: ".5rem",
                }}
              >
                <h5 style={{ marginRight: "0.5rem", color: "#08664b" }}>
                  Projects: <span>{back.public_repos}</span>
                </h5>
                <h5 style={{ marginRight: "0.5rem", color: "#08664b" }}>
                  Followers: <span>{back.followers}</span>
                </h5>
                <h5 style={{ color: "#08664b" }}>
                  Following: <span>{back.following}</span>
                </h5>
              </div>
            </div>
            <div
              className="flexColumn"
              style={{ justifyContent: "space-between", height: "100%" }}
            >
              <div>
                <p style={{ fontSize: "15px" }}>
                  I am a backend developer with 2 years experience of creating
                  interactive web services using laravel. I am also familiar
                  with frontend technologies like vue.js.
                </p>
              </div>
              <div className="flexRow mt05">
                <a
                  href="https://www.facebook.com/majharul.nayem/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/facebook.svg").default}
                    style={{ width: "24px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.linkedin.com/in/majharul-islam/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/linkedin.svg").default}
                    style={{ width: "25px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://www.github.com/majhar-nayem/"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                  style={{ marginRight: "0.5rem" }}
                >
                  <img
                    src={require("../../Assets/vectors/github.svg").default}
                    style={{ width: "24px" }}
                    alt=""
                  />
                </a>
                <a
                  href="https://twitter.com/majharul_nayem"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../Assets/vectors/twitter.svg").default}
                    style={{ width: "25px" }}
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
